export default function Preloader() {
    return (
        <div>
            <h2>Loading...</h2>
        </div>
    );
}
